import { apiClient } from "./api-client";

export interface SubscriptionInfo {
  planCode: string;
  billingStatus: string | null;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  hasStripeCustomer: boolean;
}

export async function createCheckoutSession(
  priceId: string,
): Promise<{ url: string }> {
  return apiClient<{ url: string }>("/admin/billing/checkout-session", {
    method: "POST",
    body: JSON.stringify({ priceId }),
  });
}

export async function createPortalSession(): Promise<{ url: string }> {
  return apiClient<{ url: string }>("/admin/billing/portal-session", {
    method: "POST",
  });
}

export async function getSubscription(): Promise<SubscriptionInfo> {
  return apiClient<SubscriptionInfo>("/admin/billing/subscription");
}
